import dayjs from 'dayjs';
import { DateRangeKey } from '../../../API/Enums';
import { useLocalization } from '../../../context/Localization/localization';
import { DateRangeData } from './DateRanges.types';

export const useDateRanges = (): DateRangeData[] => {
    const Localization = useLocalization();

    return [
        {
            key: DateRangeKey.today,
            title: Localization.Today,
            start: dayjs()
                .toDate(),
        },
        {
            key: DateRangeKey.yesterday,
            title: Localization.Yesterday,
            start: dayjs()
                .subtract(1, 'day')
                .toDate(),
        },
        {
            key: DateRangeKey.thisWeek,
            title: Localization.ThisWeek,
            start: dayjs()
                .startOf('week')
                .toDate(),
            end: dayjs()
                .toDate(),
        },
        {
            key: DateRangeKey.lastWeek,
            title: Localization.LastWeek,
            start: dayjs()
                .startOf('week')
                .subtract(1, 'week')
                .toDate(),
            end: dayjs()
                .endOf('week')
                .subtract(1, 'week')
                .toDate(),
        },
        {
            key: DateRangeKey.thisMonth,
            title: Localization.ThisMonth,
            start: dayjs()
                .startOf('month')
                .toDate(),
            end: dayjs()
                .toDate(),
        },
    ];
};